import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import DialogTitle from '@mui/material/DialogTitle';
import { bulkTransferCrumb } from 'utils/breadcrumbInfo';
import { checkDateRange, getDollarFormat } from 'utils/helpers';
import LOOKUP from 'constants/lookup';
import { confirmBulkTransfers, getBulkTransfers, clearBulkTransferList } from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import { showError } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
// Basic Components
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
// Advanced  Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';
import SearchFilterBulkTransfer from './searchFilterBulkTransfer';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class BulkTransfer extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            allBranches: [{
                text: "",
                value: 0
            }],
            fromWarehouse: 0,
            toWarehouse: 0,
            createdDate: null,
            activePage: 1,
            itemsPerPage: 15,
            orderBy: "DESC",
            allBranches: [],
            bulkTransferSelected: "",
            bulkTransferSelectedDialog: false,
            openTransferDialog: false,
            noTransferQuantity: [],
            noTransferQuantityDialog: false
        };
        this.newTrasnfer = this.newTrasnfer.bind(this);
        this.mapBulkTransfer = this.mapBulkTransfer.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.getBulkTransfers = this.getBulkTransfers.bind(this);
        this.confirmBulkTransfers = this.confirmBulkTransfers.bind(this);
        this.editBulkTransfer = this.editBulkTransfer.bind(this);
        this.openTransferDialog = this.openTransferDialog.bind(this);
        this.openDialogInfo = this.openDialogInfo.bind(this);
    }

    componentWillMount() {
        this.cleanSearch();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.allBranches != undefined && this.props.allBranches !== newProps.allBranches) {
            this.setState({ ...this.state, allBranches: newProps.allBranches })
        }

        if (newProps.branchId != undefined && this.state.fromWarehouse != newProps.branchId) {
            this.setState({ ...this.state, fromWarehouse: newProps.branchId, toWarehouse: this.state.toWarehouse })
        }

        if (newProps.bulkTransferSuccess != undefined && this.props.bulkTransferSuccess != newProps.bulkTransferSuccess) {
            this.setState({ ...this.state, bulkTransferSelectedDialog: false, selectedBulkTransfer: "", openTransferDialog: false })
            this.getBulkTransfers();
        }

        if (newProps.noTransferQuantity != undefined && this.props.noTransferQuantity != newProps.noTransferQuantity && newProps.noTransferQuantity.length > 0) {
            this.setState({ ...this.state, noTransferQuantity: newProps.noTransferQuantity, noTransferQuantityDialog: true, bulkTransferSelectedDialog: false, selectedBulkTransfer: "", openTransferDialog: false })
        }
    }

    componentWillUnmount() {
        this.props.clearBulkTransferList();
    }

    getBulkTransfers = () => {
        if (checkDateRange(this.props.createdDateStart, this.props.createdDateEnd) ||
            checkDateRange(this.props.completedDateStart, this.props.completedDateEnd)) {
            this.props.showError("Date Start must be before Date End");
        }
        else {
            let model = {
                fromWarehouse: this.props.fromWarehouse && this.props.fromWarehouse != "All" ? this.props.fromWarehouse : 0,
                toWarehouse: this.props.toWarehouse && this.props.toWarehouse != "All" ? this.props.toWarehouse : 0,
                transferStatus: this.props.transferStatus && this.props.transferStatus != "All" ? this.props.transferStatus : 0,
                createdDateStart: this.props.createdDateStart ? moment(this.props.createdDateStart).format('MM-DD-YYYY') : null,
                createdDateEnd: this.props.createdDateEnd ? moment(this.props.createdDateEnd).format('MM-DD-YYYY') : null,
                completedDateStart: this.props.completedDateStart ? moment(this.props.completedDateStart).format('MM-DD-YYYY') : null,
                completedDateEnd: this.props.completedDateEnd ? moment(this.props.completedDateEnd).format('MM-DD-YYYY') : null,
                page: this.state.activePage,
                itemsPerPage: this.state.itemsPerPage,
                orderBy: this.state.orderBy
            }

            this.props.getBulkTransfers(model);
        }
    }

    newTrasnfer = () => {
        this.props.navigate("/bulktransferproduct/add");
    }

    getStatus = (transferStatus) => {
        switch (transferStatus) {
            case 1:
                return "Pending"
            case 2:
                return "Completed"
            case 3:
                return "Need to Receive"
        }
    }

    getLabel = (transferStatus, needReceive) => {
        switch (transferStatus) {
            case 1:
                return needReceive ? "Transfer" : "Confirm"
            case 3:
                return "Receive"
        }
    }

    mapBulkTransfer = (value) => {
        return value != [] ? (value.map((item, index) => {
            let fromWarehouse = item.fromWarehouseBranchName + " - " + item.fromWarehouseName
            let toWarehouse = item.toWarehouseBranchName + " - " + item.toWarehouseName;

            let action = () => {
                return item.transferStatus != undefined && (item.transferStatus == 1 || item.transferStatus == 3) ? (
                    <div>
                        <div className="row mb-2">
                            <Button
                                style={{ width: "90%" }}
                                type="EditButton"
                                name="buttonCancelRemoveItem"
                                className="btn-space"
                                label={item.transferStatus == 1 ? "Edit" : "View"}
                                secondary={true}
                                onTouchTap={() => this.editBulkTransfer(item.id)}
                            />
                        </div>
                        <div className="row">
                            {
                                item.transferStatus == 1 ?
                                    item.needReceive ?
                                        <Button
                                            style={{ width: "90%", marginBottom: `5px` }}
                                            type="EditButton"
                                            id={`buttonConfirmBulkTransfer-${index}`}
                                            className="btn-space"
                                            label={this.getLabel(item.transferStatus, item.needReceive)}
                                            secondary={true}
                                            onTouchTap={() => this.openTransferDialog(item)}
                                        /> :
                                        <Button
                                            style={{ width: "90%" }}
                                            type="EditButton"
                                            id={`buttonConfirmBulkTransfer-${index}`}
                                            className="btn-space"
                                            label={this.getLabel(item.transferStatus, item.needReceive)}
                                            secondary={true}
                                            onTouchTap={() => this.openDialogInfo(item)}
                                        /> :
                                    <Button
                                        style={{ width: "90%" }}
                                        type="EditButton"
                                        className="btn-space"
                                        id={`buttonConfirmBulkTransfer-${index}`}
                                        label={this.getLabel(item.transferStatus, item.needReceive)}
                                        secondary={true}
                                        onTouchTap={() => this.openDialogInfo(item)}
                                    />
                            }
                        </div>
                    </div>
                ) : (<Button
                    style={{ width: "90%" }}
                    type="EditButton"
                    id={`buttonViewBulkTransfer-${index}`}
                    className="btn-space"
                    label="View"
                    secondary={true}
                    onTouchTap={() => this.viewBulkTransfer(item.id)}
                />
                )
            }

            let linkToDetails = (text) => {
                return <Link to={item.transferStatus == 1 ? `/bulktransferproduct/edit/${item.id}` : `/bulktransferproduct/view/${item.id}`}>
                    {text}
                </Link>

            }

            return {
                id: linkToDetails(item.id),
                title: linkToDetails(item.title),
                warehouseFrom: linkToDetails(fromWarehouse),
                warehouseTo: linkToDetails(toWarehouse),
                totalCost: linkToDetails(getDollarFormat(item.totalCost)),
                createdDate: linkToDetails(item.createdDate ? new Date(item.createdDate).toISOString().slice(0, 10) : "-"),
                completedDate: linkToDetails(item.transferStatus == 2 ? new Date(item.modifiedDate).toISOString().slice(0, 10) : "Pending"),
                transferStatus: linkToDetails(this.getStatus(item.transferStatus)),
                action: action()
            }
        })) : ""
    }

    mapBulkTransferProducts = (value) => {
        return value != undefined ? (value.map((item) => {
            return {
                productName: item.productName,
                sku: item.productSKU,
                packageReference: item.packageReference,
                quantityToTransfer: item.quantityTransfered
            }
        })) : ""
    }

    closeDialogInfo = () => {
        this.setState({ ...this.state, bulkTransferSelectedDialog: false })
    }

    openDialogInfo = (item) => {
        this.setState({ ...this.state, bulkTransferSelected: item, bulkTransferSelectedDialog: true })
    }

    openTransferDialog = (item) => {
        this.setState({ ...this.state, bulkTransferSelected: item, openTransferDialog: true })
    }

    closeTransferDialog = () => {
        this.setState({ ...this.state, openTransferDialog: false })
    }

    closeNoTransferQuantityDialog = () => {
        this.setState({ ...this.state, noTransferQuantityDialog: false })
    }

    confirmBulkTransfers = (item) => {
        this.props.confirmBulkTransfers(this.state.bulkTransferSelected.id);
    }

    editBulkTransfer = (id) => {
        this.props.navigate("/bulktransferproduct/edit/" + id);
    }

    viewBulkTransfer = (id) => {
        this.props.navigate("/bulktransferproduct/view/" + id);
    }

    cleanSearch = () => {
        this.props.clearFormInput('bulkTransferFromWarehouse');
        this.props.clearFormInput('bulkTransferFromWarehouseText');
        this.props.clearFormInput('bulkTransferToWarehouse');
        this.props.clearFormInput('bulkTransferToWarehouseText');
        this.props.clearFormInput('bulkTransferCreatedDateStart');
        this.props.clearFormInput('bulkTransferCreatedDateEnd');
        this.props.clearFormInput('bulkTransferCompletedDateStart');
        this.props.clearFormInput('bulkTransferCompletedDateEnd');
        this.props.clearFormInput('bulkTransferTransferStatus');
        this.props.clearFormInput('bulkTransferTransferStatusText');

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                orderBy: "DESC"
            };
        }, () => this.getBulkTransfers());
    }

    changePage = (item) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: item
            };
        }, this.getBulkTransfers);
    }

    render() {
        let trasnferColumns = [
            { key: "id", label: "Id", width: '80px' },
            { key: "title", label: "Title" },
            { key: "warehouseFrom", label: "From Warehouse", width: '13%' },
            { key: "warehouseTo", label: "To Warehouse", width: '13%' },
            { key: "totalCost", label: "Total Cost", width: '9%' },
            { key: "createdDate", label: "Created Date", width: '9%' },
            { key: "completedDate", label: "Completed Date", width: '9%' },
            { key: "transferStatus", label: "Status", width: '9%' },
            { key: "action", label: "Action", width: '130px' }
        ];

        return (
            <Grid headerContent={bulkTransferCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.inventory.items.bulkTransferProduct.text}>
                    <Button
                        type="AddButton"
                        mini={true}
                        className="bg-light-green"
                        label="New transfer"
                        id="buttonNewTransfer"
                        onTouchTap={() => this.newTrasnfer()}
                    />
                </PageHeaderWithButton>
                <CardSimple>
                    {
                        this.state.allBranches.length > 0 ? (
                            <SearchFilterBulkTransfer pageName="bulkTransfer"
                                allBranchesFrom={this.state.allBranches}
                                allBranchesTo={this.state.allBranches}
                                search={this.getBulkTransfers} />
                        ) : ("")
                    }
                </CardSimple>
                <CardSimple>
                    <GenericTable
                        compName="bulkTransferTable"
                        columns={trasnferColumns}
                        rows={this.mapBulkTransfer(this.props.bulkTransferList || [])}
                        stripedRows={true}
                    />
                    <Pagination
                        length={this.props.bulkTransferListLength || 0}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                        style={{ textAlign: 'center' }}
                        onPageChange={this.changePage}
                        maxButtons={8}
                    />
                </CardSimple>
                <DialogInput
                    title={<DialogHeaderWithClose text={"Bulk Transfer #" + this.state.bulkTransferSelected.id} classicClass="posDialogClassic" handleClose={() => this.closeDialogInfo()} />}
                    actions={([
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialogInfo()}
                        />,
                        <Button
                            key={3}
                            type="SaveButtonNoIcon"
                            id="dialogConfirmTransfer1"
                            className="btn-space"
                            label={"Confirm"}
                            onTouchTap={() => this.confirmBulkTransfers(this.state.bulkTransferSelected.id)}
                        />
                    ])}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.bulkTransferSelectedDialog}
                >
                    <div >
                        <div className="bg-light-opacity pb-3">
                            <div className="searchBarContainer">
                                {
                                    this.state.bulkTransferSelectedDialog && this.state.bulkTransferSelected != {} && this.state.bulkTransferSelected != undefined ? (
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Title :</td>
                                                    <td>{this.state.bulkTransferSelected.title}</td>
                                                </tr>
                                                {
                                                    this.state.bulkTransferSelected.transferStatus != 3 ? (
                                                        <tr>
                                                            <td>From :</td>
                                                            <td>{this.state.bulkTransferSelected.fromWarehouseBranchName + " - " + this.state.bulkTransferSelected.fromWarehouseName}</td>
                                                        </tr>
                                                    ) : (
                                                        <tr>
                                                            <td>From :</td>
                                                            <td>{this.state.bulkTransferSelected.fromWarehouseBranchName + " - Storage (temporarily)"}</td>
                                                        </tr>
                                                    )
                                                }
                                                <tr>
                                                    <td>To :</td>
                                                    <td>{this.state.bulkTransferSelected.toWarehouseBranchName + " - " + this.state.bulkTransferSelected.toWarehouseName}</td>
                                                </tr>
                                                <tr>
                                                    <td>Created Date :</td>
                                                    <td>{new Date(this.state.bulkTransferSelected.createdDate).toISOString().slice(0, 10)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Status :</td>
                                                    <td>{this.getStatus(this.state.bulkTransferSelected.transferStatus)}</td>
                                                </tr>
                                                {
                                                    this.state.bulkTransferSelected.transferStatus == 2 ? (
                                                        <tr>
                                                            <td>Completed Date :</td>
                                                            <td>{new Date(this.state.bulkTransferSelected.modifiedDate).toISOString().slice(0, 10)}</td>
                                                        </tr>
                                                    ) : ("")
                                                }
                                            </tbody>
                                        </table>
                                    ) : ("")
                                }
                            </div>
                        </div>
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text={"Bulk Transfer #" + this.state.bulkTransferSelected.id} classicClass="posDialogClassic" handleClose={() => this.closeTransferDialog()} />}
                    actions={([
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeTransferDialog()}
                        />,
                        <Button
                            key={3}
                            type="SaveButtonNoIcon"
                            id="dialogConfirmTransfer2"
                            className="btn-space"
                            label={"Confirm"}
                            onTouchTap={() => this.confirmBulkTransfers(this.state.bulkTransferSelected.id)}
                        />

                    ])}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.openTransferDialog}
                >
                    <div className="bg-light-opacity pb-3" style={{ padding: 20, fontSize: 16 }}>
                        <p>You are about to transfer products from {this.state.bulkTransferSelected.fromWarehouseBranchName + " - " + this.state.bulkTransferSelected.fromWarehouseName} to {this.state.bulkTransferSelected.toWarehouseBranchName + " - Storage (temporarily)"}. Are you sure you want to continue? </p>
                    </div>
                </DialogInput>
                <DialogInput
                    actions={([
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeNoTransferQuantityDialog()}
                        />,
                        <Button
                            key={3}
                            type="SaveButtonNoIcon"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={"Confirm"}
                            onTouchTap={() => this.closeNoTransferQuantityDialog()}
                        />
                    ])}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.noTransferQuantityDialog}
                >
                    <p>Transfer successful. The following products have not been transferred as you have entered 0 for Quantity to Transfer:</p>
                    <ul>
                        {this.state.noTransferQuantity.map((item) => <li>{item}</li>)}
                    </ul>
                </DialogInput> : <div></div>
            </Grid>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let allBranches = [];
    allBranches.push({ text: "All", value: "All" });
    if (state.common.userBranches != null && state.common.userBranches.length > 1 && state.common.branchId != null) {
        for (let i = 0; i < state.common.userBranches.length; i++) {
            allBranches.push({
                text: state.common.userBranches[i].name,
                value: state.common.userBranches[i].id
            })
        }
    }
    return {
        branchId: state.common.branchId,
        allBranches: allBranches,
        bulkTransferList: state.entity.bulkTransferList ? state.entity.bulkTransferList.list : [],
        bulkTransferListLength: state.entity.bulkTransferListLength,
        bulkTransferSuccess: state.entity.bulkTransferSuccess,
        fromWarehouse: state.form.bulkTransferFromWarehouse,
        toWarehouse: state.form.bulkTransferToWarehouse,
        createdDateStart: state.form.bulkTransferCreatedDateStart,
        createdDateEnd: state.form.bulkTransferCreatedDateEnd,
        completedDateStart: state.form.bulkTransferCompletedDateStart,
        completedDateEnd: state.form.bulkTransferCompletedDateEnd,
        transferStatus: state.form.bulkTransferTransferStatus,
        noTransferQuantity: state.entity.bulkTransferNoQuantity
    };
}

function mapDispatchToProps(dispatch) {
    return {
        formError: (name, error) => dispatch(formError(name, error)),
        formInput: (name, value) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getBulkTransfers: (model) => dispatch(getBulkTransfers(model)),
        confirmBulkTransfers: (model) => dispatch(confirmBulkTransfers(model)),
        clearBulkTransferList: () => dispatch(clearBulkTransferList())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(BulkTransfer));